// // ============================================================
// // src/App.js
// // ✅ PearlSmile root uses slug "pearlsmile" for token isolation
// // ============================================================
// import React, { useState } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./context/AuthContext";
// import { HospitalProvider } from "./context/HospitalContext";
// import Navbar from "./components/Navbar";
// import Hero from "./components/Hero";
// import Ticker from "./components/Ticker";
// import Services from "./components/Services";
// import Pricing from "./components/Pricing";
// import WhyUs from "./components/WhyUs";
// import Doctors from "./components/Doctors";
// import Gallery from "./components/Gallery";
// import Testimonials from "./components/Testimonials";
// import Appointment from "./components/Appointment";
// import Insurance from "./components/Insurance";
// import FAQ from "./components/FAQ";
// import Footer from "./components/Footer";
// import AdminModal from "./components/admin/AdminModal";
// import BackToTop from "./components/BackToTop";
// import Toast from "./components/Toast";
// import VidyaOne from "./pages/VidyaOne";
// import HospitalPage from "./pages/HospitalPage";
// import "./styles/global.css";

// export const ToastContext = React.createContext(null);

// // ── PearlSmile main app ───────────────────────────────────────
// export function PearlSmileApp() {
//   const [adminOpen, setAdminOpen] = useState(false);
//   const [toast, setToast] = useState({ show: false, message: "" });

//   const showToast = (message) => {
//     setToast({ show: true, message });
//     setTimeout(() => setToast({ show: false, message: "" }), 4000);
//   };

//   return (
//     // ✅ PearlSmile uses slug "pearlsmile" → token key = "pearlsmile_token_pearlsmile"
//     <AuthProvider hospitalSlug="pearlsmile">
//       <HospitalProvider>
//         <ToastContext.Provider value={{ showToast }}>
//           <div className="App">
//             <Navbar onAdminClick={() => setAdminOpen(true)} />
//             <Hero />
//             <Ticker />
//             <Services />
//             <Pricing />
//             <WhyUs />
//             <Doctors />
//             <Gallery />
//             <Testimonials />
//             <Appointment showToast={showToast} />
//             <Insurance />
//             <FAQ />
//             <Footer />
//             {adminOpen && (
//               <AdminModal
//                 onClose={() => setAdminOpen(false)}
//                 showToast={showToast}
//               />
//             )}
//             <BackToTop />
//             <Toast show={toast.show} message={toast.message} />
//           </div>
//         </ToastContext.Provider>
//       </HospitalProvider>
//     </AuthProvider>
//   );
// }

// // ── Root App with Router ──────────────────────────────────────
// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* ✅ Vidya One = Homepage */}
//         <Route path="/" element={<VidyaOne />} />

//         {/* ✅ Each hospital's full page */}
//         <Route path="/hospital/:slug" element={<HospitalPage />} />

//         {/* ✅ PearlSmile direct access */}
//         <Route path="/pearlsmile" element={<PearlSmileApp />} />
//       </Routes>
//     </BrowserRouter>
//   );
// // }

// // ============================================================
// // src/App.js
// // ✅ SuperAdmin route added at /superadmin
// // ============================================================
// import React, { useState } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./context/AuthContext";
// import { HospitalProvider } from "./context/HospitalContext";
// import Navbar from "./components/Navbar";
// import Hero from "./components/Hero";
// import Ticker from "./components/Ticker";
// import Services from "./components/Services";
// import Pricing from "./components/Pricing";
// import WhyUs from "./components/WhyUs";
// import Doctors from "./components/Doctors";
// import Gallery from "./components/Gallery";
// import Testimonials from "./components/Testimonials";
// import Appointment from "./components/Appointment";
// import Insurance from "./components/Insurance";
// import FAQ from "./components/FAQ";
// import Footer from "./components/Footer";
// import AdminModal from "./components/admin/AdminModal";
// import BackToTop from "./components/BackToTop";
// import Toast from "./components/Toast";
// import VidyaOne from "./pages/VidyaOne";
// import HospitalPage from "./pages/HospitalPage";
// import SuperAdmin from "./pages/SuperAdmin"; // ✅ NEW
// import "./styles/global.css";

// export const ToastContext = React.createContext(null);

// // ── PearlSmile main app ───────────────────────────────────────
// export function PearlSmileApp() {
//   const [adminOpen, setAdminOpen] = useState(false);
//   const [toast, setToast] = useState({ show: false, message: "" });

//   const showToast = (message) => {
//     setToast({ show: true, message });
//     setTimeout(() => setToast({ show: false, message: "" }), 4000);
//   };

//   return (
//     <AuthProvider hospitalSlug="pearlsmile">
//       <HospitalProvider>
//         <ToastContext.Provider value={{ showToast }}>
//           <div className="App">
//             <Navbar onAdminClick={() => setAdminOpen(true)} />
//             <Hero />
//             <Ticker />
//             <Services />
//             <Pricing />
//             <WhyUs />
//             <Doctors />
//             <Gallery />
//             <Testimonials />
//             <Appointment showToast={showToast} />
//             <Insurance />
//             <FAQ />
//             <Footer />
//             {adminOpen && (
//               <AdminModal
//                 onClose={() => setAdminOpen(false)}
//                 showToast={showToast}
//               />
//             )}
//             <BackToTop />
//             <Toast show={toast.show} message={toast.message} />
//           </div>
//         </ToastContext.Provider>
//       </HospitalProvider>
//     </AuthProvider>
//   );
// }

// // ── Root App with Router ──────────────────────────────────────
// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* VidyaOne homepage */}
//         <Route path="/" element={<VidyaOne />} />
//         {/* Each hospital's full page */}
//         <Route path="/hospital/:slug" element={<HospitalPage />} />
//         {/* PearlSmile direct access */}
//         <Route path="/pearlsmile" element={<PearlSmileApp />} />
//         {/* ✅ Super Admin Panel — secured by username/password */}
//         <Route path="/superadmin" element={<SuperAdmin />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// prenjeev
// ============================================================
// src/App.js
// ✅ SuperAdmin route added at /superadmin
// ✅ Rebranded: VidyaOne → PranJeev
// ============================================================
import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { HospitalProvider } from "./context/HospitalContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import WhyUs from "./components/WhyUs";
import Doctors from "./components/Doctors";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Appointment from "./components/Appointment";
import Insurance from "./components/Insurance";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import AdminModal from "./components/admin/AdminModal";
import BackToTop from "./components/BackToTop";
import Toast from "./components/Toast";
import PranJeev from "./pages/PranJeev";
import HospitalPage from "./pages/HospitalPage";
import SuperAdmin from "./pages/SuperAdmin";
import "./styles/global.css";

export const ToastContext = React.createContext(null);

// ── PearlSmile main app ───────────────────────────────────────
export function PearlSmileApp() {
  const [adminOpen, setAdminOpen] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });

  const showToast = (message) => {
    setToast({ show: true, message });
    setTimeout(() => setToast({ show: false, message: "" }), 4000);
  };

  return (
    <AuthProvider hospitalSlug="pearlsmile">
      <HospitalProvider>
        <ToastContext.Provider value={{ showToast }}>
          <div className="App">
            <Navbar onAdminClick={() => setAdminOpen(true)} />
            <Hero />
            <Ticker />
            <Services />
            <Pricing />
            <WhyUs />
            <Doctors />
            <Gallery />
            <Testimonials />
            <Appointment showToast={showToast} />
            <Insurance />
            <FAQ />
            <Footer />
            {adminOpen && (
              <AdminModal
                onClose={() => setAdminOpen(false)}
                showToast={showToast}
              />
            )}
            <BackToTop />
            <Toast show={toast.show} message={toast.message} />
          </div>
        </ToastContext.Provider>
      </HospitalProvider>
    </AuthProvider>
  );
}

// ── Root App with Router ──────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PranJeev homepage */}
        <Route path="/" element={<PranJeev />} />
        {/* Each hospital's full page */}
        <Route path="/hospital/:slug" element={<HospitalPage />} />
        {/* PearlSmile direct access */}
        <Route path="/pearlsmile" element={<PearlSmileApp />} />
        {/* Super Admin Panel — secured by username/password */}
        <Route path="/superadmin" element={<SuperAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}
